/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUser200ResponseNotifications } from './GetUser200ResponseNotifications';
import {
    GetUser200ResponseNotificationsFromJSON,
    GetUser200ResponseNotificationsFromJSONTyped,
    GetUser200ResponseNotificationsToJSON,
    GetUser200ResponseNotificationsToJSONTyped,
} from './GetUser200ResponseNotifications';
import type { GetUser200ResponseOnboarding } from './GetUser200ResponseOnboarding';
import {
    GetUser200ResponseOnboardingFromJSON,
    GetUser200ResponseOnboardingFromJSONTyped,
    GetUser200ResponseOnboardingToJSON,
    GetUser200ResponseOnboardingToJSONTyped,
} from './GetUser200ResponseOnboarding';

/**
 * Keycloak user object
 * @export
 * @interface GetUser200Response
 */
export interface GetUser200Response {
    /**
     * 
     */
    firstName: string;
    /**
     * 
     */
    lastName: string;
    /**
     * 
     */
    email: string;
    /**
     * 
     */
    notifications: GetUser200ResponseNotifications;
    /**
     * 
     */
    onboarding?: GetUser200ResponseOnboarding;
}

/**
 * Check if a given object implements the GetUser200Response interface.
 */
export function instanceOfGetUser200Response(value: object): value is GetUser200Response {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('notifications' in value) || value['notifications'] === undefined) return false;
    return true;
}

export function GetUser200ResponseFromJSON(json: any): GetUser200Response {
    return GetUser200ResponseFromJSONTyped(json, false);
}

export function GetUser200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUser200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'notifications': GetUser200ResponseNotificationsFromJSON(json['notifications']),
        'onboarding': json['onboarding'] == null ? undefined : GetUser200ResponseOnboardingFromJSON(json['onboarding']),
    };
}

export function GetUser200ResponseToJSON(json: any): GetUser200Response {
    return GetUser200ResponseToJSONTyped(json, false);
}

export function GetUser200ResponseToJSONTyped(value?: GetUser200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'notifications': GetUser200ResponseNotificationsToJSON(value['notifications']),
        'onboarding': GetUser200ResponseOnboardingToJSON(value['onboarding']),
    };
}

